import { supabase } from "./supabase.ts";

// Gemeindegrenzen als FeatureCollection (Quelle: View boundaries_geojson).
export async function loadBoundaries(): Promise<GeoJSON.FeatureCollection> {
  const { data, error } = await supabase.from("boundaries_geojson").select("*");
  if (error) throw error;
  return {
    type: "FeatureCollection",
    features: (data ?? []).map((row) => ({
      type: "Feature",
      geometry: row.geojson as GeoJSON.Geometry,
      properties: { ags: row.ags as string, name: (row.name as string | null) ?? null },
    })),
  };
}
